import { useAuthentication as useSharedAuthentication } from '@starjack/features/authentication';
import {
    deleteFromLocalStorage,
    getFromLocalStorage,
    saveToLocalStorage,
} from '@/utils';
import { LOCAL_STORAGE_KEY_AUTH, isB2B } from '@/constants';
import { isOfTypeBackendError, isOfTypeString } from '@/utils/guards';

export const useAuthentication = () => {
    return useSharedAuthentication({
        isB2B,
        localStorageKey: LOCAL_STORAGE_KEY_AUTH,
        getFromLocalStorage,
        saveToLocalStorage,
        deleteFromLocalStorage,
        isOfTypeBackendError,
        isOfTypeString,
        extractAuthOptions: {
            tokenExpiresAtOffset: undefined, // Uses validFor (getUnixTime + validFor)
            usePermissionsFromJwt: true, // Admin uses permissions from JWT
        },
        refreshTimeLeftMultiplier: undefined, // Will use (validFor - 180) when tokenExpiresAtOffset is checked
        enableUrlAuth: true,
    }) as ReturnType<typeof useSharedAuthentication> & {
        login: (
            username: string,
            password: string
        ) => Promise<[unknown, string | null]>;
        logout: () => void;
        isLoggedIn: () => [boolean, 'no_jwt' | 'token_expired' | null];
        saveAuthDataFromUrl: () => boolean;
        authenticateFromLocalStorageData: () => boolean;
    };
};
